import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Flex from '~/common/components/Flex';
import SelectedCategoryNavContainer from '~/common/components/Nav/components/SelectedCategoryNavContainer';
import { NavItem } from '~/common/components/Nav/components/Styled';
import {
  getNumberOfActiveAlertsForCategory,
  isTopNavCategoryVerified,
} from '~/common/util/topNavigationIcon';

import Notification from './Notification';
import { CATEGORY_DETAILS, CATEGORY_IDS } from './constants';
import { HomeActions } from './redux';

const CategoriesNav = () => {
  // redux
  const dispatch = useDispatch();
  const { home } = useSelector((state) => state);
  const selectedCategory = home?.selectedCategory;
  const allCategories = useMemo(
    () => home?.navigationItems?.categories,
    [home],
  );

  // event handlers
  const handleCategoryClick = (categoryId: number) => {
    if (categoryId !== CATEGORY_IDS.UNDERWRITER_FINAL_REVIEW) {
      dispatch(HomeActions.setIsUnderwriterCheckboxDisabled(false));
    }
    // return the match categoryId key name from CATEGORY_IDS
    const categoryNavName = Object.keys(CATEGORY_IDS).find(
      (key) => CATEGORY_IDS[key] === categoryId,
    );

    dispatch(HomeActions.setSelectedAlert(null));
    dispatch(HomeActions.setClickedSelectedCategory(categoryNavName));
    dispatch(HomeActions.setSelectedCategory(categoryId));
  };

  return (
    <SelectedCategoryNavContainer>
      {CATEGORY_DETAILS.map((category) => {
        const currentCategory = allCategories?.find(
          (item) => item?.navigationCategoryId === category.id,
        );
        return (
          currentCategory && (
            <NavItem
              onClick={() => handleCategoryClick(category.id)}
              selected={selectedCategory === category.id}
              key={category.id}
              role="tab"
              data-testid={category.name}
              data-tracking={category.name}
              aria-selected={selectedCategory === category.id}
            >
              <Flex alignItems="center">
                <Notification
                  currentCategoryId={category.id}
                  numberOfActiveAlerts={getNumberOfActiveAlertsForCategory(
                    currentCategory,
                  )}
                  isVerified={isTopNavCategoryVerified(currentCategory)}
                />
                <span>{category.name}</span>
              </Flex>
            </NavItem>
          )
        );
      })}
    </SelectedCategoryNavContainer>
  );
};

export default CategoriesNav;
